export default (data) => ((data?.nativeEvent ?? data) instanceof Event ? undefined : data);
